import { Action } from 'redux';

import { SetLinkEnabledSite } from '~src/bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '~src/bootstrap/redux/actions/isActionFactory';


export interface SetLinkEnabledSiteAction extends Action {
  isLinkEnabledSite: boolean;
}

export function setLinkEnabledSite(isLinkEnabledSite: boolean): SetLinkEnabledSiteAction {
  return {
    type: SetLinkEnabledSite,
    isLinkEnabledSite
  };
}
export const isSetLinkEnabledSiteAction = isActionFactory<SetLinkEnabledSiteAction>(SetLinkEnabledSite);
